import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import ViewColumnOutlinedIcon from '@mui/icons-material/ViewColumnOutlined';
import ViewStreamOutlinedIcon from '@mui/icons-material/ViewStreamOutlined';

const ContextMenu = ({ contextMenu, handleClose, verticalLayout, onLayoutChange }) => {
  return (
    <Menu
      id="basic-menu"
      anchorReference="anchorPosition"
      anchorPosition={
        Boolean(contextMenu.position)
          ? { top: contextMenu.position.mouseY, left: contextMenu.position.mouseX }
          : undefined
      }
      open={Boolean(contextMenu.position)}
      onClose={handleClose}
    >
      <MenuItem onClick={onLayoutChange}>
        <ListItemIcon>
          {verticalLayout ? <ViewColumnOutlinedIcon fontSize="small" /> : <ViewStreamOutlinedIcon fontSize="small" />}
        </ListItemIcon>
        <ListItemText>{verticalLayout ? 'Egymás melletti nézet' : 'Egymás alatti nézet'}</ListItemText>
      </MenuItem>
    </Menu>
  );
};

export default ContextMenu;
